import { put, call } from "redux-saga/effects";
import {   SAVE_EAD_SUCCESS,SAVE_EAD_FAILED,GET_EADPETITION_SUCCESS,GET_EADPETITION_FAILED, CREATE_EADPETITION_SUCCESS,CREATE_EADPETITION_FAILED,UPDATE_EADPETITION_SUCCESS,UPDATE_EADPETITION_FAILED,
    SAVE_EADFORMSUBMIT_SUCCESS,SAVE_EADFORMSUBMIT_FAILED} from "../actions/VisaCareEADCase";
import { VisaCareEADAPI } from "../../utils/api/VisaCareEADAPI";
export function* edaCaseQuestion(request: any) {
    
    try {
        
         const result=yield call(VisaCareEADAPI.EADCase, request.input);
      
        yield put({ 
            type: SAVE_EAD_SUCCESS,     
            payload: result.data,
            input: request.input
        });
    } catch (e) {
        yield put({ type: SAVE_EAD_FAILED, payload: e.message });
    }
}

export function* getEADPetition (request:any) {
    try {
      
        const { data } = yield call(VisaCareEADAPI.getEADPetition,request);
   
 
      yield put({
          type: GET_EADPETITION_SUCCESS,
          payload: data 
        });
    } catch (e) {
        yield put({ type: GET_EADPETITION_FAILED, payload: e.message });
    }
}

  export function* createEADPetition (request:any) {
    try {
      
        const { data } = yield call(VisaCareEADAPI.createEADPetition,request);
    
      yield put({
          type: CREATE_EADPETITION_SUCCESS,
          payload: data 
        });
    } catch (e) {
        yield put({ type: CREATE_EADPETITION_FAILED, payload: e.message });
    }
  }

  export function* updateEADPetition (request:any) {
    try {
      
        const { data } = yield call(VisaCareEADAPI.updateEADPetition,request);
    
      yield put({
          type: UPDATE_EADPETITION_SUCCESS,
          payload: data 
        });
    } catch (e) {
        yield put({ type: UPDATE_EADPETITION_FAILED, payload: e.message });
    }
  }

  export function* eadPdfFormSubmit (request:any) {
    try {
      
        const { data } = yield call(VisaCareEADAPI.eadPdfFormSubmit,request);
    
      yield put({
          type: SAVE_EADFORMSUBMIT_SUCCESS,
          payload: data 
        });
    } catch (e) {
        yield put({ type: SAVE_EADFORMSUBMIT_FAILED, payload: e.message });
    }
  }
       
